import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { 
  IoHomeOutline, 
  IoHome, 
  IoDocumentTextOutline, 
  IoDocumentText,
  IoWalletOutline,
  IoWallet, 
  IoPersonOutline, 
  IoPerson 
} from "react-icons/io5";

const BottomNav = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.pathname);
  
  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  const navItems = [
    { 
      name: "Home", 
      path: "/dashboard", 
      icon: IoHomeOutline,
      activeIcon: IoHome
    },
    { 
      name: "Invoices", 
      path: "/dashboard/invoices", 
      icon: IoDocumentTextOutline,
      activeIcon: IoDocumentText
    },
    {
      name: "Payments",
      path: "/dashboard/payments",
      icon: IoWalletOutline,
      activeIcon: IoWallet
    },
    { 
      name: "Account", 
      path: "/dashboard/settings", 
      icon: IoPersonOutline,
      activeIcon: IoPerson
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      {/* Blur background */}
      <div className="absolute inset-0 bg-white/80 backdrop-blur-lg border-t border-slate-200"></div>
      
      {/* Navigation items */}
      <div className="relative flex items-center justify-around h-16 px-2 mx-auto max-w-md">
        {navItems.map((item) => {
          const isActive = activeTab === item.path;
          const Icon = isActive ? item.activeIcon : item.icon;
          
          return (
            <Link
              to={item.path}
              key={item.name}
              className="relative flex flex-col items-center justify-center w-full h-full"
              onClick={() => setActiveTab(item.path)}
            >
              {isActive && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute inset-0 bg-slate-100 rounded-full mx-2"
                  initial={false}
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                />
              )}
              
              <motion.div
                initial={{ y: 8 }}
                animate={{ y: isActive ? 0 : 8 }}
                transition={{ duration: 0.2 }}
                className="relative flex flex-col items-center"
              >
                <Icon 
                  className={`w-5 h-5 ${
                    isActive 
                      ? "text-slate-800" 
                      : "text-slate-400"
                  }`}
                />
                
                <span
                  className={`text-[10px] font-medium mt-0.5 ${
                    isActive 
                      ? "opacity-100 text-slate-800" 
                      : "opacity-0"
                  } transition-opacity`}
                >
                  {item.name}
                </span>
              </motion.div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;